// extracted by mini-css-extract-plugin
export default {"page":"moon_page__5uvxU"};